import {
	formatChambre,
	formatDate,
	formatCapitalize,
	formatActeur,
	formatVotePosition,
	formatRow,
	formatCell,
} from "../formatters";
import { formatType, formatCode } from "./scrutins";
import { VoteIcon } from "@logora/parliament.icons.regular_icons";

const columns = [
	{
		header: "Chambre",
		accessorKey: "scrutinRef.chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				key: "scrutinRef_chambre",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "dateVote",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Votant",
		accessorKey: "acteurRef",
		cell: (info) => formatActeur(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Position",
		accessorKey: "positionVote",
		cell: (info) => formatVotePosition(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Position",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "pour", label: "Pour" },
					{ value: "contre", label: "Contre" },
					{ value: "abstention", label: "Abstention" },
				],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "scrutinRef.typeObjet",
		cell: (info) => formatType(formatRow(info).scrutinRef),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				key: "scrutinRef_typeObjet",
				options: [
					{ value: null, label: "Tous" },
					{ value: "amendement", label: "Amendement" },
					{ value: "article", label: "Article" },
					{ value: "projetLoi", label: "Projet de loi" },
					{ value: "propositionLoi", label: "Proposition de loi" },
					{ value: "motionCensure", label: "Motion de censure" },
					{ value: "motionRejet", label: "Motion de rejet" },
					{ value: "motionReferendaire", label: "Motion référendaire" },
					{
						value: "propositionResolution",
						label: "Proposition de résolution",
					},
				],
			},
		},
	},
	{
		header: "Objet",
		accessorKey: "scrutinRef.titre",
		cell: (info) => formatCapitalize(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Votes",
		accessorKey: "scrutinRef.nombreVotants",
		sortBy: "scrutinRef_nombreVotants",
	},
	{
		header: "Résultat",
		accessorKey: "scrutinRef.code",
		cell: (info) => formatCode(formatRow(info).scrutinRef),
		meta: {
			filter: {
				label: "Résultat",
				variant: "select",
				key: "scrutinRef_code",
				options: [
					{ value: null, label: "Tous" },
					{ value: "adopté", label: "Adopté" },
					{ value: "rejeté", label: "Rejeté" },
				],
			},
		},
	},
];

export const voteDataset = {
	key: "votes",
	name: "Votes",
	columns: columns,
	include: [
		"acteurRef.groupeParlementaire",
		"acteurRef.mandatPrincipal",
		"scrutinRef",
	],
	searchTable: "acteurRef",
	searchPlaceholder: "Chercher un parlementaire...",
	icon: <VoteIcon width={20} height={20} />,
	rowRedirect: (item) => `/parliament/acteurs/${item.acteurRefUid}`,
};
